import React from "react";
import { T } from "../../app/tokens.js";
import { COLLECTION_PROGRESS as P, COLLECTION_ONE_LINE } from "./listPresentation.js";

// Presentation only. Callers own completeness, phase aliases and lifecycle.
// Retained readers opt into their original small inline presentation.
export function ProgressDots({
  steps, complete = false, compact = false, caption, shortCaption, tooltip = caption,
  retained = false, testId = "progress-dots", dotsTestId, captionTestId, dotTestId,
}) {
  return (
    <span data-testid={testId} data-layout={retained ? "retained" : compact ? "compact" : "standard"}
      title={tooltip} aria-label={caption}
      style={{ display: "inline-flex", flexDirection: retained || compact ? "row" : "column",
        alignItems: "center", justifyContent: "center", gap: retained ? 6 : compact ? 8 : 2,
        maxWidth: "100%", minWidth: 0, verticalAlign: "middle", lineHeight: 1 }}>
      <span data-testid={dotsTestId} aria-hidden="true"
        style={{ display: "flex", alignItems: "center", gap: retained ? 3 : P.gap, flexShrink: 0 }}>
        {steps.map((step, i) => {
          const state = complete ? "done" : step.state;
          const current = !retained && state === "current";
          const color = retained
            ? ({ done: T.projectsPhaseDone, current: T.projectsPhaseCurrent, upcoming: T.projectsPhaseFuture })[state]
            : complete ? P.complete : state === "done" ? P.done : P.remaining;
          return <span key={step.key ?? i} data-testid={dotTestId?.(i)} data-state={state}
            data-set={state === "done" ? "true" : "false"}
            style={{ display: "block", boxSizing: "border-box", width: retained ? 7 : P.size,
              height: retained ? 7 : P.size, borderRadius: "50%", flexShrink: 0,
               ...(!retained && { flex: "none", aspectRatio: "1" }),
              background: current ? "transparent" : color,
              border: current ? `${P.ring}px solid ${P.current}` : "none" }} />;
        })}
      </span>
      <span data-testid={captionTestId} style={{ ...COLLECTION_ONE_LINE,
        fontSize: retained ? "inherit" : compact ? T.fsXs : T.fsXxxs5,
        lineHeight: retained ? "inherit" : "12px", color: complete && !retained ? T.green : "inherit",
        fontWeight: complete && !retained ? T.fwSemibold : "inherit" }}>
        {compact && !retained ? shortCaption : caption}
      </span>
    </span>
  );
}
